import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";
import { putRequestPAdmin } from "common/HttpClient/http-utility";
import { refreshUserProfileFromMe } from "common/Auth/InitializeUserSessionFromMe";

const resolveCustomerId = (customer) => {
  const raw = customer?.id ?? customer?.customerId;
  if (raw == null || String(raw).trim() === "") {
    return null;
  }
  const numeric = Number(raw);
  return Number.isFinite(numeric) ? numeric : raw;
};

export const putMeActiveCustomerRequest = async (customer) => {
  const customerId = resolveCustomerId(customer);
  const customerCode = String(
    customer?.customerCode
  ).trim();

  if (customerId == null || !customerCode) {
    return { error: "Invalid customer selection." };
  }

  const path = INFRAMARK_CONSTANTS.login.services.meActiveCustomer;
  const response = await putRequestPAdmin(path, { customerId, customerCode });

  if (response?.error) {
    return { error: response.error };
  }

  return { success: true, customerId, customerCode };
};

export const setMeActiveCustomer = async (profile, customer, loadUserInformation) => {
  const putResult = await putMeActiveCustomerRequest(customer);
  if (putResult?.error) {
    return { error: putResult.error };
  }

  return refreshUserProfileFromMe(profile, loadUserInformation);
};
